import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { Required } from 'ZalamoLibrary/src/lib/core/decorators/Required';
import { ZalamoObject } from 'ZalamoLibrary/src/lib/zalamo/pipes/names/graphql';
import { combineLatest, ReplaySubject } from 'rxjs';
import { first, map, switchMap, tap } from 'rxjs/operators';
import { FramePickerService } from '@ui/look-book-front/print-frames/print-frames-front/frame-picker.service';
import { select, Store } from '@ngrx/store';
import {
  addPrintFrameAction,
  changePrintFrameCountAction,
  deletePrintFrameAction,
} from '@ui/products/shopping-cart-back/actions/actions';
import cuid from 'cuid';
import { selectPrintFramesInBasket } from '@ui/products/shopping-cart-back/actions/selector';

@Component({
    selector: 'lib-print-frame-picker-full-screen',
    templateUrl: './print-frame-picker-full-screen.component.html',
    styleUrls: ['./print-frame-picker-full-screen.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrintFramePickerFullScreenComponent implements OnInit {
  sceneImages = [0, 1, 2];
  currentScene = new UntypedFormControl(0);

  @Input() set printSizeId(printSizeId: string) {
    this.printSizeId$.next(printSizeId);
  }

  @Input() set ratio(ratio: number) {
    this.ratio$.next(ratio);
  }

  @Input() set photoId(photoId: string) {
    this.photoId$.next(photoId);
  }

  close = new EventEmitter();
  @Input() @Required context: ZalamoObject;
  @Input() @Required contextId: string;
  firstSort = [];
  optionsModel = new UntypedFormArray([]);
  printSizeId$ = new ReplaySubject<string>(1);
  ratio$ = new ReplaySubject<number>(1);
  photoId$ = new ReplaySubject<string>(1);
  options$ = this.printSizeId$.pipe(
    tap((printSizeId) => {
      if (printSizeId === '22') {
        this.sceneImages = [2];
      }
    }),
    switchMap((printSizeId) =>
      this.framePickerService.getOptionsForSize(printSizeId)
    ),
    map((options) => {
      if (this.firstSort.length === 0) {
        this.firstSort = options.map((option) => JSON.stringify(option.value));
      }
      console.log(this.firstSort);
      return options.sort((a, b) => {
        return (
          this.firstSort.indexOf(JSON.stringify(a.value)) -
          this.firstSort.indexOf(JSON.stringify(b.value))
        );
      });
    })
  );

  @Input() set currentFrame(selected) {
    this.currentConfig.next(selected);
  }

  currentConfig = new ReplaySubject(1);

  constructor(
    public framePickerService: FramePickerService,
    private elementRef: ElementRef,
    private store: Store
  ) {}

  ngOnInit(): void {
    // this.printSizeId =
  }

  trackFrame(index, frame) {
    return JSON.stringify(frame.value);
  }

  add(value, price) {
    combineLatest([
      this.printSizeId$,
      this.ratio$,
      this.photoId$,
      this.store.pipe(select(selectPrintFramesInBasket)),
    ])
      .pipe(
        first(),
        tap(([printSizeId, ratio, photoId, printFramesInBasket]) => {
          const frame = printFramesInBasket.find(
            (frame) =>
              frame.photoId === photoId &&
              frame.printFormatId === printSizeId &&
              frame.value === JSON.stringify(value)
          );
          if (frame) {
            this.store.dispatch(
              changePrintFrameCountAction({
                photoId,
                printFrameId: frame.printFrameId,
                count: frame.count + 1,
              })
            );
          } else {
            this.store.dispatch(
              addPrintFrameAction({
                printFrame: {
                  printFormatId: printSizeId,
                  ratio,
                  photoId,
                  value: JSON.stringify(value),
                  price,
                  printFrameId: cuid(),
                },
              })
            );
          }
        })
      )
      .subscribe();
  }

  remove(value) {
    combineLatest([
      this.printSizeId$,
      this.ratio$,
      this.photoId$,
      this.store.pipe(select(selectPrintFramesInBasket)),
    ])
      .pipe(
        first(),
        tap(([printSizeId, ratio, photoId, printFramesInBasket]) => {
          const frame = printFramesInBasket.find(
            (frame) =>
              frame.photoId === photoId &&
              frame.printFormatId === printSizeId &&
              frame.value === JSON.stringify(value)
          );
          if (frame.count === 1) {
            this.store.dispatch(
              deletePrintFrameAction({
                photoId,
                printFrameId: frame.printFrameId,
              })
            );
          } else {
            this.store.dispatch(
              changePrintFrameCountAction({
                photoId,
                printFrameId: frame.printFrameId,
                count: frame.count - 1,
              })
            );
          }
        })
      )
      .subscribe();
  }

  goRight() {
    if (this.currentScene.value === this.sceneImages.length - 1) {
      this.currentScene.patchValue(this.sceneImages[0]);
    } else {
      this.currentScene.patchValue(this.currentScene.value + 1);
    }
  }

  goLeft() {
    if (this.currentScene.value === 0) {
      this.currentScene.patchValue(this.sceneImages.length - 1);
    } else {
      this.currentScene.patchValue(this.currentScene.value - 1);
    }
  }
}
